import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { SettingsService } from '@api/settings.service';
import { ScreenLessThanPipe } from '@shared/pipes/screen-less-than.pipe';
import { BreakpointTypeEnum } from '@shared/types/screen-breakpoints';

@Component({
  selector: 'app-dialog-notification',
  templateUrl: './dialog-notification.component.html',
  styleUrls: ['./dialog-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.--bottom-sheet]': 'bottomSheet',
    '[class.no-paddings]': 'noPaddings',
    '[class.no-bg]': 'noBg',
    '[class.mobile]': `SCREEN_PIPE.transform(settingsService.screenBreakpoint$.value, BreakpointTypeEnum.HalfSmall)`,
  },
})
export class DialogNotificationComponent {
  @Input() public calculatePosition = true;
  @Input() public showCloseButton = true;
  @Input() public bottomSheet = false;
  @Input() public noPaddings = false;
  @Input() public noBg = false;

  @Output() public readonly closeEvent = new EventEmitter<void>();

  public SCREEN_PIPE = new ScreenLessThanPipe();
  public readonly BreakpointTypeEnum = BreakpointTypeEnum;
  public Math = Math;

  constructor(
    public settingsService: SettingsService,
    public cd: ChangeDetectorRef,
  ) {}

  public _onCloseClick(): void {
    this.closeEvent.next();
  }
}
